/**
 * `/app/files` — the route. The page is `pages/client/files/`.
 *
 * A route file is the address and the guard; the page is the screen. Keeping them
 * apart is what lets a page test mount the page over the recorded world without the
 * router's own tree (`test/clientPage.tsx`), and it is why every one of these is
 * four lines.
 */

import { createFileRoute } from '@tanstack/react-router'

import { FilesPage, FilesSearchSchema } from '../../pages/client/files/FilesPage.js'
import { routeSearch } from '../../search/useSearchState.js'

export const Route = createFileRoute('/app/files')({
  /**
   * `?view=month|project|credentials` and `?period=YYYY-MM` — the page owns both,
   * so they are declared here as well as read through `useSearchState`, exactly as
   * `/app/projects` declares `show`. `/app`'s own `validateSearch` knows only
   * `notice`, so without this the two keys are typed off the route and a
   * `<Link to="/app/files" search={{ view, period }}>` — which is what the
   * earlier-months table needs — does not compile.
   *
   * `FilesSearchSchema`'s fields already `.catch(undefined)`, so this route never
   * threw. It goes through `routeSearch` anyway: the rule is one rule, and a
   * schema that is safe because somebody remembered `.catch` on both fields is a
   * schema that is one new field away from not being.
   */
  validateSearch: routeSearch(FilesSearchSchema),
  component: FilesPage,
})
